import * as React from 'react';
import { UitkBadge, UitkDealGenericBadge } from 'uitk-react-badge';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { ViewSmall, Viewport } from 'bernie-view';
import { ActivityBadgeType, ActivityDestinationViewSearch } from '../../../../common/__generated__/api';
import { getBadgeProps } from '../../../../helpers/badge-helper';
import Badges = ActivityDestinationViewSearch.Badges;
import Icon = ActivityDestinationViewSearch.Icon;
import Mark = ActivityDestinationViewSearch.Mark;

interface ImageBadgesProps {
  badges?: Badges;
  isVerticalLayout: boolean;
}

export const getBadge = (
  text: string | undefined | null,
  icon: Icon | undefined | null,
  mark: Mark | undefined | null,
  type: ActivityBadgeType,
  styleClasses?: string | null
): JSX.Element => {
  const props = getBadgeProps(type, icon, mark, text, styleClasses);

  return <UitkBadge {...props} />;
};

export const ImageBadges: React.FC<ImageBadgesProps> = ({ badges, isVerticalLayout }) => {
  const renderBadge = (): JSX.Element => {
    const primary = badges && badges.primary ? badges.primary : undefined;
    const secondary = badges && badges.secondary ? badges.secondary : undefined;

    const badgeClasses = `uitk-type-bold uitk-type-200`;
    const isCampaignDeal = primary && primary.type === ActivityBadgeType.CAMPAIGN_DEAL;

    if (isCampaignDeal) {
      return (
        <>
          <UitkLayoutPosition
            type="absolute"
            position={{ top: 'three', left: 'three', zindex: 'layer2' }}
            data-testid="activity-primary-badge"
          >
            <UitkBadge text={primary && primary.text ? primary.text : ''} className={badgeClasses}>
              {primary?.icon && <UitkIcon name={primary.icon.id} />}
            </UitkBadge>
          </UitkLayoutPosition>
          {secondary && (
            <Viewport>
              <ViewSmall>
                <UitkLayoutPosition
                  type="absolute"
                  position={{ right: 'minus-three', zindex: 'layer2' }}
                  data-testid="activity-secondary-badge"
                >
                  <UitkDealGenericBadge
                    text={secondary && secondary.text ? secondary.text : ''}
                    className={`${badgeClasses}`}
                  />
                </UitkLayoutPosition>
              </ViewSmall>
            </Viewport>
          )}
        </>
      );
    }

    return (
      <>
        {primary && (
          <UitkLayoutPosition
            type="absolute"
            position={{ top: 'three', left: 'three', zindex: 'layer2' }}
            data-testid="activity-primary-badge"
          >
            {getBadge(primary.text, primary.icon, primary.mark, primary.type, badgeClasses)}
          </UitkLayoutPosition>
        )}
        {secondary && isVerticalLayout ? (
          <UitkLayoutPosition
            type="absolute"
            position={{ bottom: 'minus-three', right: 'three', zindex: 'layer7' }}
            data-testid="activity-secondary-badge"
          >
            {getBadge(secondary.text, secondary.icon, secondary.mark, secondary.type, badgeClasses)}
          </UitkLayoutPosition>
        ) : secondary ? (
          getBadge(secondary.text, secondary.icon, secondary.mark, secondary.type, badgeClasses)
        ) : (
          ''
        )}
      </>
    );
  };

  return <>{renderBadge()}</>;
};
